import { render, staticRenderFns } from "./jobs-by-homeowner.vue?vue&type=template&id=54148e80&scoped=true"
import script from "./jobs-by-homeowner.vue?vue&type=script&lang=js"
export * from "./jobs-by-homeowner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54148e80",
  null
  
)

export default component.exports